import { RpcBaseData } from './rpc-base';

/**
 * RPC Observable request context.
 */
export interface RpcObservableRequestContext {
    /**
     * Source manifest name.
     */
    sourceName?: string;

    /**
     * Source path name with instance id.
     */
    sourceSubName?: string;

    /**
     * version.
     */
    sourceVersion?: string;
}

/**
 * The RPC Observable request packet format.
 */
export interface RpcObservableRequest<TRequest extends RpcObservableRequestContext> extends RpcBaseData {
    /**
     * Request identity.
     */
    id: number;

    /**
     * The request data.
     */
    request: TRequest;
}
